import {RouteView, PageView} from '../layouts'

export const integral = {
  path: '/integral',
  redirect: '/integral/integral',
  meta: { title: '积分活动管理', icon: 'skin', isMenuShow:true, permission: 'lottery'},
  component:PageView,
  children: [
    {
      path: '/integral/integral',
      redirect: '/integral/secretCode/recordDraw',
      name: 'integral',
      component: () => import('../views/integral/integral.vue'),
      meta: {title: '小积分抽大奖活动', icon: 'skin', isMenuShow: true, permission: 'lottery:point'},
      children: [
        {
          path: '/integral/secretCode/recordDraw',
          name: 'recordDraw',
          component: () => import('../views/integral/secretCode/recordDraw.vue'),
          meta: {title: '抽奖记录', keepAlive: false, isMenuShow: true, permission: 'lottery:point:record'},
        },
        {
          path: '/integral/secretCode/activeConfig',
          name: 'activeConfig',
          component: () => import('../views/integral/secretCode/activeConfig.vue'),
          meta: {title: '活动配置', keepAlive: false, isMenuShow: true, permission: 'lottery:point:arg'},
        },
      ]
    },
    {
      path: '/integral/wheel',
      redirect: '/integral/wheelCode/recordDraw',
      name: 'integral',
      component: () => import('../views/integral/wheel.vue'),
      meta: {title: '盲盒活动', icon: 'skin', isMenuShow: true, permission: 'lottery:white'},
      children: [
        {
          path: '/integral/wheelCode/recordDraw',
          name: 'recordDraw',
          component: () => import('../views/integral/wheelCode/recordDraw.vue'),
          meta: {title: '抽奖记录', keepAlive: false, isMenuShow: true, permission: 'lottery:white:record'},
        },
        {
          path: '/integral/wheelCode/activeConfig',
          name: 'activeConfig',
          component: () => import('../views/integral/wheelCode/activeConfig.vue'),
          meta: {title: '活动配置', keepAlive: false, isMenuShow: true, permission: 'lottery:white:arg'},
        },
        {
          path: '/integral/wheelCode/joinPeople',
          name: 'joinPeople',
          component: () => import('../views/integral/wheelCode/joinPeople.vue'),
          meta: {title: '参与人员', keepAlive: false, isMenuShow: true, permission: 'lottery:white:user'},
        },
      ]
    },
    {
      path: '/integral/draw',
      redirect: '/integral/drawCode/recordDraw',
      name: 'integral',
      component: () => import('../views/integral/draw.vue'),
      meta: {title: '新年翻牌活动', icon: 'skin', isMenuShow: true, permission: 'lottery:year'},
      children: [
        {
          path: '/integral/drawCode/recordDraw',
          name: 'recordDraw',
          component: () => import('../views/integral/drawCode/recordDraw.vue'),
          meta: {title: '抽奖记录', keepAlive: false, isMenuShow: true, permission: 'lottery:year:record'},
        },
        {
          path: '/integral/drawCode/activeConfig',
          name: 'activeConfig',
          component: () => import('../views/integral/drawCode/activeConfig.vue'),
          meta: {title: '活动配置', keepAlive: false, isMenuShow: true, permission: 'lottery:year:arg'},
        },
        {
          path: '/integral/drawCode/joinPeople',
          name: 'joinPeople',
          component: () => import('../views/integral/drawCode/joinPeople.vue'),
          meta: {title: '参与人员', keepAlive: false, isMenuShow: true, permission: 'lottery:year:user'},
        },
      ]
    },
    {
      path: '/integral/spring',
      redirect: '/integral/embraceSpring/recordDraw',
      name: 'integral',
      component: () => import('../views/integral/spring.vue'),
      meta: {title: '拥抱春日活动', icon: 'skin', isMenuShow: true, permission: 'lottery:spring'},
      children: [
        {
          path: '/integral/embraceSpring/recordDraw',
          name: 'recordDraw',
          component: () => import('../views/integral/embraceSpring/recordDraw.vue'),
          meta: {title: '抽奖记录', keepAlive: false, isMenuShow: true, permission: 'lottery:spring:record'},
        },
        {
          path: '/integral/embraceSpring/activeConfig',
          name: 'activeConfig',
          component: () => import('../views/integral/embraceSpring/activeConfig.vue'),
          meta: {title: '活动配置', keepAlive: false, isMenuShow: true, permission: 'lottery:spring:arg'},
        },
      ]
    },
    {
      path: '/integral/treasureHunt',
      name: 'BaseForm',
      component: () => import('../views/integral/treasure'),
      meta: { title: '寻宝活动', icon: 'dollar', isMenuShow: true, permission: 'lottery:treasure' },
    },
    {
      path: '/integral/treasureCreate',
      name: 'BaseForm',
      component: () => import('../views/integral/treasure/create'),
      meta: { title: '创建活动', icon: 'dollar', isMenuShow: false, permission: 'lottery:treasure' },
    },
  ]
}
